/**
 * @generated SignedSource<<df738ef7932ca49fb1fe4807f9b0dc4e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AttachmentEditor_TreeNodeFragment$data = {
  readonly attachments: ReadonlyArray<{
    readonly attachmentType?: string | null | undefined;
    readonly description?: string | null | undefined;
    readonly file?: {
      readonly id: string;
      readonly name: string;
    } | null | undefined;
    readonly id: string;
    readonly title?: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"AttachmentForm_InfectopharmFileAttachmentFragment">;
  }>;
  readonly id: string;
  readonly " $fragmentType": "AttachmentEditor_TreeNodeFragment";
};
export type AttachmentEditor_TreeNodeFragment$key = {
  readonly " $data"?: AttachmentEditor_TreeNodeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AttachmentEditor_TreeNodeFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AttachmentEditor_TreeNodeFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "attachments",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "attachmentType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "File",
              "kind": "LinkedField",
              "name": "file",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "InfectopharmFileAttachment",
          "abstractKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AttachmentForm_InfectopharmFileAttachmentFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TreeNode",
  "abstractKey": null
};
})();

(node as any).hash = "24c3e481ccec9ee7f78c74ebea035c5f";

export default node;
